import { helper as buildHelper } from "@ember/component/helper"
import { htmlSafe } from "@ember/template"

export function safeString(params /*, hash*/) {
  return params ? htmlSafe(params.join("")) : ""
}

export default buildHelper(safeString)
